// extracted by mini-css-extract-plugin
module.exports = {"bannerComponent":"va","red":"wa","calloutlink":"xa","headerTopBanner":"ya","bgcolorRed":"za","headerTopCallout":"Aa","searchBanner":"Ba","hideMobile":"Ca"};